import createIcon from '../../createIcon';

/**
 * @component @name Earbuds
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNNi4yIDMuMDA3MDdDNC40NCAyLjg4NzA3IDMgNC40MTcwNyAzIDYuMTg3MDdWMTUuOTk3MUMzIDE4Ljc1NzEgNS4yNCAyMC45OTcxIDggMjAuOTk3MUMxMC43NiAyMC45OTcxIDEzIDE4Ljc1NzEgMTMgMTUuOTk3MVY3Ljk5NzA3QzEzIDYuMzM3MDcgMTQuMzQgNC45OTcwNyAxNiA0Ljk5NzA3QzE3LjY2IDQuOTk3MDcgMTkgNi4zMzcwNyAxOSA3Ljk5NzA3VjE0Ljk5NzFIMTguMTdDMTYuNTYgMTQuOTk3MSAxNS4xMSAxNi4xNzcxIDE1IDE3Ljc4NzFDMTQuODggMTkuNDc3MSAxNi4xNiAyMC44ODcxIDE3LjggMjAuOTk3MUMxOS41NiAyMS4xMTcxIDIxIDE5LjU3NzEgMjEgMTcuODE3MVY3Ljk5NzA3QzIxIDUuMjM3MDcgMTguNzYgMi45OTcwNyAxNiAyLjk5NzA3QzEzLjI0IDIuOTk3MDcgMTEgNS4yMzcwNyAxMSA3Ljk5NzA3VjE1Ljk5NzFDMTEgMTcuNjU3MSA5LjY2IDE4Ljk5NzEgOCAxOC45OTcxQzYuMzQgMTguOTk3MSA1IDE3LjY1NzEgNSAxNS45OTcxVjguOTk3MDdINS44M0M3LjQ0IDguOTk3MDcgOC44OSA3LjgxNzA3IDkgNi4yMDcwN0M5LjExIDQuNTI3MDcgNy44MyAzLjEwNzA3IDYuMiAzLjAwNzA3WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Earbuds = createIcon('Earbuds', [
  [
    'path',
    {
      d: 'M6.2 3.00707C4.44 2.88707 3 4.41707 3 6.18707V15.9971C3 18.7571 5.24 20.9971 8 20.9971C10.76 20.9971 13 18.7571 13 15.9971V7.99707C13 6.33707 14.34 4.99707 16 4.99707C17.66 4.99707 19 6.33707 19 7.99707V14.9971H18.17C16.56 14.9971 15.11 16.1771 15 17.7871C14.88 19.4771 16.16 20.8871 17.8 20.9971C19.56 21.1171 21 19.5771 21 17.8171V7.99707C21 5.23707 18.76 2.99707 16 2.99707C13.24 2.99707 11 5.23707 11 7.99707V15.9971C11 17.6571 9.66 18.9971 8 18.9971C6.34 18.9971 5 17.6571 5 15.9971V8.99707H5.83C7.44 8.99707 8.89 7.81707 9 6.20707C9.11 4.52707 7.83 3.10707 6.2 3.00707Z',
      key: 'fkaaf2',
    },
  ],
]);

export default Earbuds;
